import Card from "../../components/shared/card";
import Typography from "../../components/shared/typography";

type Props = {
  displayName: string;
  specialty?: string | null;
  city?: string | null;
  state?: string | null;
};

export default function ProviderSummaryCard({ displayName, specialty, city, state }: Props) {
  return (
    <>
      <Typography variant="body1" className="text-brown-700 mb-2">
        You’re requesting records from:
      </Typography>
      <Card variant="cream" elevation={1} className="mb-10">
        <Card.Body className="space-y-1">
          <Typography variant="h5" className="text-brown-900">
            {displayName}
          </Typography>
          {specialty && (
            <Typography variant="body2" className="text-brown-700">
              Specialty: {specialty}
            </Typography>
          )}
          {(city || state) && (
            <Typography variant="body2" className="text-brown-700">
              Location: {[city, state].filter(Boolean).join(", ")}
            </Typography>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

